import React from 'react';

import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import RedirectLink from 'pages/Search/components/RedirectLink';

import useStyles from './styles';

interface Props {
    className?: string;
    items: {
        link: string;
        label: string;
        disabled?: boolean;
    }[];
}

const Breadcrumbs: React.FC<Props> = (props) => {
    const { className, items } = props;
    const { classes, cx } = useStyles();
    return (
        <MuiBreadcrumbs
            separator={<span className={classes.separator}>{'/'}</span>}
            className={cx(classes.root, className)}
        >
            {items.map(({ link, label, disabled }, index) => (
                <RedirectLink key={index} to={link} label={label} active={!disabled} className={classes.link} />
            ))}
        </MuiBreadcrumbs>
    );
};

export default Breadcrumbs;
